<ion-row>
  <ion-col size="12">
    <ion-item lines="none">
      <ion-button (click)="copyMatchId()" fill="clear" slot="start">
        <ion-icon class="ion-padding-end" size="default" slot="icon-only" name="copy"></ion-icon>
        _id: {{ match._id }}
      </ion-button>

      @if (!isRossSubscribed()) {
        <ion-button (click)="subscribe()" slot="end">
          <ion-icon slot="icon-only" name="cloud-upload"></ion-icon>
        </ion-button>
      } @else {
        <ion-button color="success" (click)="unsubscribe()" slot="end">
          <ion-icon name="cloud-offline"></ion-icon>
        </ion-button>
      }

    </ion-item>
  </ion-col>
</ion-row>
